module.exports = __webpack_public_path__ + "static/media/newOrder.6d8d8f2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newOrder.mp3
// module id = XvUQ
// module chunks = 1